/* eslint react/no-array-index-key: 0 */
/* global jQuery */

import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import _str from "shared/util/_str";

import "./SearchWithSuggestionsResults.scss";

class SearchResults extends Component {
	// scroll the active result to the middle of the dropdown
	componentDidUpdate() {
		if (this.props.activeResult === null) {
			return;
		}

		const results = jQuery(".search-and-select-results");
		const item = jQuery(".search-and-select-result.active");
		const currentItemTop = item.position().top + results.scrollTop();
		const desiredItemTop = (results.outerHeight() - item.outerHeight()) / 2;
		const newScroll = currentItemTop - desiredItemTop;

		results.scrollTop(newScroll);
	}

	render() {
		let results;
		let resultClasses;

		if (this.props.results && this.props.results.length) {
			results = this.props.results.map((result, i) => {
				resultClasses = classnames({
					"search-and-select-result": true,
					"active": i === this.props.activeResult,
				});

				// assemble the result string here so we can
				// dangerouslySetItAsInnerHTML
				let resultText = result.text;

				if (result.subtext) {
					resultText += `<span className="subtext"><br />${result.subtext}</span>`;
				}

				return (
					<li key={i}>
						<button
							onClick={this.props.resultClick.bind(null, result)}
							className={resultClasses}
							dangerouslySetInnerHTML={{ __html: resultText }}
						/>
					</li>
				);
			});
		} else {
			results = (
				<li>
					<div className="content">
						{_str("No results")}
					</div>
				</li>
			);
		}

		return (
			<ul className="search-and-select-results">
				{results}
			</ul>
		);
	}
}

SearchResults.propTypes = {
	results: PropTypes.array,
	activeResult: PropTypes.number,
	resultClick: PropTypes.func.isRequired,
};

export default SearchResults;



// WEBPACK FOOTER //
// ./src/shared/components/SearchWithSuggestionsResults.jsx